import React, { createContext, useContext } from "react"
import type { ReactNode } from "react"
import type { SavedColors } from "./saved-colors-section"

// `undefined` means no provider above, which the panel reports in development
const SavedColorsContext = createContext<SavedColors | undefined>(undefined)

export function useSavedColorsContext(): SavedColors | undefined {
  return useContext(SavedColorsContext)
}

export type SavedColorsProviderProps = {
  /** The account's saved colors, and how to add or edit them */
  savedColors: SavedColors
  children?: ReactNode
}

/**
 * Supplies the account's saved colors to every `ColorInput` and `ColorPanel`
 * below it. They're account-level, so it mounts once, high in the app.
 */
export function SavedColorsProvider({
  savedColors,
  children
}: SavedColorsProviderProps) {
  return (
    <SavedColorsContext.Provider value={savedColors}>
      {children}
    </SavedColorsContext.Provider>
  )
}

SavedColorsProvider.displayName = "SavedColorsProvider"
